<template>
  <div class="chart-component" v-loading="chartLoading">
    <el-table class="table-content" :data="tableInfo.rowData" stripe border :resizable="false">
      <el-table-column
        v-for="(headItem, headIndex) in tableInfo.headData"
        :key="headItem.uniqueId"
        :width="headIndex === tableInfo.headData.length - 1 ? '-' : '200'"
        min-width="200"
      >
        <template #header>
          <el-tooltip effect="dark" :content="headItem.val" placement="top" :open-delay="300">
            <el-dropdown
              v-if="showSort && statisticNameEnum[headItem.val]"
              class="head-content could-sort"
              placement="bottom-start"
              @command="action => sortHandle(action, headItem)"
            >
              <div>
                <span v-show="sortInfo.name === headItem.val">
                  <i v-show="sortInfo.type === 'asc'" class="iconfont iconshengxu sort-icon"></i>
                  <i v-show="sortInfo.type === 'desc'" class="iconfont iconjiangxu sort-icon"></i>
                </span>
                <span class="single-ellipsis">{{ headItem.val }}</span>
                <span class="expand-icon">
                  <i class="el-icon-arrow-down"></i>
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="asc">升序</el-dropdown-item>
                <el-dropdown-item command="desc">降序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="head-content single-ellipsis" v-else>
              <span>{{ headItem.val }}</span>
            </div>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div v-html="formatNumText(scope.row, headItem)"></div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { uniqueId } from 'lodash';
import chartComponent from './mixins/chart-component';
import { fetchStatisticValKey } from '@/lib/utils';

export default {
  mixins: [chartComponent],
  data() {
    return {
      tableInfo: {
        headData: [],
        rowData: []
      }
    };
  },
  props: {
    showSort: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Array,
      default: () => []
    },
    statistics: {
      type: Array,
      default: () => []
    },
    sortStatistic: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    chartType() {
      return 'tableChart';
    },
    statisticNameEnum() {
      const nameEnum = {};
      const nameArr = [];
      this.rows.forEach(rowItem => {
        if (['num', 'date'].includes(rowItem.type)) {
          nameArr.push(rowItem.title);
        }
      });
      if (this.statistics.length > 0) {
        this.statistics.forEach(statisticItem => {
          nameArr.push(fetchStatisticValKey(statisticItem, this.relationStatisticItem));
        });
      } else {
        nameEnum[this.relationStatisticItem.statisticName] = true;
      }
      nameArr.forEach(name => (nameEnum[name] = true));
      return nameEnum;
    },
    rowsNameEnum() {
      const nameEnum = {};
      this.rows.forEach(rowItem => {
        nameEnum[rowItem.title] = true;
      });
      return nameEnum;
    },
    sortInfo() {
      if (this.rows.length < 1) {
        return { type: 'none' };
      }
      if (Object.keys(this.sortStatistic || {}).length > 0) {
        return this.sortStatistic;
      }
      const rowItem = this.rows.find(item => {
        return ['num', 'date'].includes(item.type);
      });
      if (rowItem) {
        return { name: rowItem.title, type: 'asc' };
      }
      return { name: fetchStatisticValKey(this.statistics[0], this.relationStatisticItem), type: 'desc' };
    }
  },
  methods: {
    formatNumText(row, headItem) {
      const val = row[headItem.val] || '-';
      if (isNaN(val) || this.rowsNameEnum[headItem.val]) {
        return val;
      }
      return val.toLocaleString();
    },
    initDataHandle(params) {
      const { originData } = params || {};
      const { columnsData = [], rowsData = [] } = originData || {};
      this.tableInfo = {
        headData: columnsData.map(val => {
          return { uniqueId: uniqueId(), val };
        }),
        rowData: rowsData
      };
      return { type: this.chartType, isChart: false };
    },
    sortHandle(action, headItem) {
      if (!this.statisticNameEnum[headItem.val]) {
        return;
      }

      const { name, type } = this.sortInfo;

      if (name === headItem.val) {
        if (action === type) {
          this.$emit('sortHandle', { name: headItem.val, type: 'none' });
        } else {
          this.$emit('sortHandle', { name: headItem.val, type: action });
        }
      } else {
        this.$emit('sortHandle', { name: headItem.val, type: action });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-component {
  height: 100%;
  overflow: auto;
  ::v-deep .head-content {
    width: 100%;
    position: relative;
    font-size: 12px;
    .sort-icon {
      margin-right: 3px;
      font-size: 12px;
      color: #409eff;
      &.drak-icon {
        color: rgba(#2c3443, 0.8);
      }
    }

    .el-dropdown-selfdefine {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .expand-icon {
      margin-left: 3px;
    }

    &.could-sort {
      cursor: pointer;
    }
  }

  ::v-deep .table-content {
    .cell {
      display: flex;
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}
</style>
